import React,{useState} from 'react'
import './psswrd.css'
import '../Card/addoverlay.css'
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";

const PasswordInputField = ({handleValidation, handlePasswordChange, passwordValue, passwordError})=>{
    const [visible, setVisible] = useState(true)

    const handleVisIcon = () =>{
        setVisible(!visible)
    }

    return (
            <div className="bnwpswrd-field">
                <input  id="bnw-firname-box_" placeholder="Password" type={visible ? "password":"text"} value={passwordValue}  onChange={handlePasswordChange} onKeyUp={handleValidation} name="password" className="form-control" />
                <p className="text-danger">{passwordError}</p>
                { visible ? <MdOutlineVisibility id='visib-icon' onClick={handleVisIcon}/> : <MdOutlineVisibilityOff id='visib-icon' onClick={handleVisIcon}/> }
            </div>
    )
}
export default PasswordInputField;